import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

// Create userStore for persisting user session in localStorage
const userStore = new WebStorageStateStore({ store: window.localStorage });

// OIDC Configuration for Dex
export const oidcConfig: AuthProviderProps = {
  authority: import.meta.env.VITE_OIDC_AUTHORITY || "https://localhost/oauth",
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID || "webapp",
  redirect_uri:
    import.meta.env.VITE_OIDC_REDIRECT_URI ||
    `${window.location.origin}/callback`,
  post_logout_redirect_uri: window.location.origin,
  // "groups" puts the IdP groups into the token — the backend's group
  // mappings (management_group_mappings) depend on it
  scope:
    import.meta.env.VITE_OIDC_SCOPE ||
    "openid profile email groups audience:server:client_id:lcc-api",
  response_type: "code",
  automaticSilentRenew: true,
  loadUserInfo: false, // Disabled due to CORS - user info comes from ID token instead
  // Persist user session in localStorage to survive page refresh
  userStore: userStore,
  // After successful login, clean up URL and navigate to dashboard
  // The library stores the user in userStore automatically before this callback
  onSigninCallback: (_user) => {
    // Remove the code and state from the URL after successful login
    // Use history.replaceState to clean up the URL without triggering a page reload
    // This prevents losing the auth state that was just set
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

// Authorization Service URL (for room permissions)
export const AUTH_SERVICE_URL =
  import.meta.env.VITE_AUTH_SERVICE_URL || "http://localhost:3010";
